import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { TRANSLATE_PREFIX } from '../../consts';
import Input from '../Input';
import css from './DescriptionCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;
const paramT = key => `${TAB_PREFIX}.PARAMS.${key.toUpperCase()}`;

const DescriptionCell = ({ row, setParam, readOnly }) => {
    const { isCustomRow, index, description, singular_key: singularKey } = row;
    if (isCustomRow) {
        return (
            <td>
                <Input
                    value={description}
                    onChange={val => setParam(index, 'description', val)}
                    placeholder={readOnly ? null : `${TAB_PREFIX}.CUSTOM_DESCRIPTION_PLACEHOLDER`}
                    disabled={readOnly}
                />
            </td>
        );
    }
    return (
        <td>
            <span className={css.description}>
                <Translate id={`${paramT(singularKey)}.DESCRIPTION`} />
            </span>
        </td>
    );
};

DescriptionCell.propTypes = {
    row: PropTypes.shape({
        isCustomRow: PropTypes.bool.isRequired,
        index: PropTypes.number.isRequired,
        singular_key: PropTypes.string,
        description: PropTypes.string,
    }).isRequired,
    setParam: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
};

export default DescriptionCell;
